import PropTypes from 'prop-types';
import React from 'react';

import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { ModalDialog, ModalDialogMessages as messages } from 'ecs-react-components/dist/index.es';
import CompleteQuestionnaire from '../../containers/Questionnaires/CompleteQuestionnaire';
import { questionnaireAnswerCleared }
  from '../../redux/modules/questionnaires/questionnaires-action-creator';
import 'react-datepicker/dist/react-datepicker.css';

import 'rc-slider/assets/index.css';
import { withAuth } from '../../containers/Authenticated';


class CompleteQuestionnairePage extends React.Component {
  constructor() {
    super();
    this.state = {
      isShowCancelModal: false,
      nextRoute: '',
      isSubmitting: false,
    };
  }

  componentDidMount() {
    this.allowRouteToChange = false;

    if (this.props.history) {
      this.unblockRouter = this.props.history.block((next) => {
        if (!this.state.isShowCancelModal && !this.state.isSubmitting) {
          this.setState({
            isShowCancelModal: true,
            nextRoute: next.pathname,
          });
        } else {
          this.setState({
            nextRoute: next.pathname,
          }, () => this.submitCancelModal());
        }

        return this.allowRouteToChange;
      });
    }
  }

  componentWillUnmount() {
    if (this.unblockRouter) {
      this.unblockRouter();
    }
  }

  setNoModalToRoute = () => {
    this.setState({
      isShowCancelModal: false,
      isSubmitting: true,
    });

    this.allowRouteToChange = true;
  }

  submitCancelModal = () => {
    this.setState({
      isShowCancelModal: false,
    });

    this.allowRouteToChange = true;

    this.props.dispatch(questionnaireAnswerCleared(this.props.selectedQuestionnaireId));

    this.props.history.push(this.state.nextRoute);
  }

  hideCancelModal = () => {
    this.setState({
      isShowCancelModal: false,
    });

    this.allowRouteToChange = false;
  }

  allowRouteToChange = false;

  render() {
    return (<div id="home-tabs-navs-contents">
            <CompleteQuestionnaire onSubmit={this.setNoModalToRoute} history={this.props.history}/>
            <ModalDialog show={this.state.isShowCancelModal}
              title={messages.cancelModal.title}
              message={messages.cancelModal.message }
              submitBtnText={ messages.cancelModal.submitBtnText }
              hideBtnText={messages.cancelModal.hideBtnText.button}
              onSubmit={this.submitCancelModal}
              onHide={this.hideCancelModal}
              id={ this.props.selectedQuestionnaireId }
            />
            </div>);
  }
}

CompleteQuestionnairePage.propTypes = {
  history: PropTypes.object,
  dispatch: PropTypes.func,
  selectedQuestionnaireId: PropTypes.string,
};

const mapStateToProps = (state) => ({
  selectedQuestionnaireId: state.questionnaires.selectedQuestionnaireId,
  completeQuestionnairePage: state.questionnaires.completeQuestionnairePage,
});

const CompleteQuestionnairePageWithAuth = withAuth(CompleteQuestionnairePage);

export default withRouter(connect(mapStateToProps)(CompleteQuestionnairePageWithAuth));